import type { App } from "@grafikr/components";

import hasUrlParam from "utils/loaders/has-url-param";
import intersectionLoader from "utils/loaders/intersection";
import onElementInteraction from "utils/loaders/on-element-interaction";
import onEvent from "utils/loaders/on-event";
import anchors from "components/anchor-links";
import toTop from "components/to-top";
import tableOfContents from 'components/fixed-table-of-contents'
import digitalPassportDrawer from "components/digital-passport-drawer";

import collectionFilter from "pages/collection/filter";

import shopTheLook from "pages/product/shop-the-look";

export default (app: App) => {
  app.add({
    // Components
    "to-top": toTop,
    "fixed-table-of-contents": tableOfContents,
    anchors,
    "navigation-drawer": [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-navigation-drawer" */ "components/navigation-drawer"),
    ],
    "navigation-item-drawer": [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-navigation-item-drawer" */ "components/navigation-item-drawer"),
    ],
    video: [intersectionLoader, () => import(/* webpackChunkName: "component-video" */ "components/video")],
    "instagram-gallery": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-instagram-gallery" */ "components/instagram-gallery"),
    ],
    slider: [intersectionLoader, () => import(/* webpackChunkName: "component-slider" */ "components/slider")],
    collapsible: ["click", () => import(/* webpackCunkName: "component-collapsible" */ "components/collapsible")],
    "scroll-to": ["click", () => import(/* webpackCunkName: "component-scroll-to" */ "components/scroll-to")],
    "open-drawer": ["click", () => import(/* webpackCunkName: "component-open-drawer" */ "components/open-drawer")],
    "sizeguide-drawer": [
      onElementInteraction,
      () => import(/* webpackCunkName: "component-sizeguide-drawer" */ "components/sizeguide-drawer"),
    ],
    "quick-add": [onElementInteraction, () => import(/* webpackChunkName: "quick-add" */ "components/quick-add")],
    "quick-shop": ["click", () => import(/* webpackChunkName: "quick-shop" */ "components/quick-shop")],
    "cart-drawer": [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ "components/cart-drawer"),
    ],
    "cart-count": [onEvent, () => import(/* webpackChunkName: "component-cart-count" */ "components/cart-count")],
    "hero-slider": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-hero-slider" */ "components/hero-slider"),
    ],
    "product-item": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-item" */ "components/product-item"),
    ],
    "count-to-number": [
      intersectionLoader, 
      () => import(/* webpackChunkName: "component-count-to-number" */ "components/count-to-number"),
    ],
    "discount-pricing": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-discount-pricing" */ "components/discount-pricing"),
    ],
    "product-item-media": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-product-item-media" */ "components/product-item-media"),
    ],
    "password-hero": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-password-hero" */ "components/password-hero"),
    ],
    "featured-products": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-featured-products" */ "components/featured-products"),
    ],
    "shop-the-look-drawer": [
      "click",
      () => import(/* webpackChunkName: "component-shop-the-look-drawer" */ "components/shop-the-look-drawer"),
    ],
    pagination: [
      [intersectionLoader, "filter:update"],
      () => import(/* webpackChunkName: "component-pagination" */ "components/pagination"),
    ],
    accordion: [intersectionLoader, () => import(/* webpackChunkName: "component-accordion" */ "components/accordion")],
    "featured-collections": [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-featured-collections" */ "components/featured-collections"),
    ],

    // pages

    // Product
    product: [intersectionLoader, () => import(/* webpackChunkName: "product-main" */ "pages/product/main")],
    "product-media": [intersectionLoader, () => import(/* webpackChunkName: "product-media" */ "pages/product/media")],
    "product-form": [intersectionLoader, () => import(/* webpackChunkName: "product-form" */ "pages/product/form")],
    "shop-the-look": shopTheLook,
    "recommended-products": [
      intersectionLoader,
      () => import(/* webpackCunkName: "product-recommended-products" */ "pages/product/recommended-products"),
    ],
    "digital-passport-drawer": digitalPassportDrawer,

    // Collection
    collection: [intersectionLoader, () => import(/* webpackChunkName: "collection-main" */ "pages/collection/main")],
    "collection-filter": collectionFilter,
    "collection-subcollection": [
      intersectionLoader,
      () => import(/* webpackChunkName: "collection-subcollection" */ "pages/collection/subcollection"),
    ],
  });
};
